var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": _vm.labelPosition,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(`${_vm.type}Manage.${_vm.type}No`),
                            prop: "ssrNo",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: {
                              disabled: "",
                              value: _vm.formData.serialNo,
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Initiator" } },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: {
                              value: _vm.formData.creator,
                              clearable: "",
                              disabled: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Creation Date" } },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: {
                              disabled: true,
                              value: _vm._f("dateFormatFilter")(
                                _vm.formData.createDate
                              ),
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ssrManage.category1"),
                            prop: "category1Id",
                            rules: _vm.rules.category1Id,
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: !_vm.canEditCategory,
                                clearable: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeCategory1()
                                },
                              },
                              model: {
                                value: _vm.formData.category1Id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "category1Id", $$v)
                                },
                                expression: "formData.category1Id",
                              },
                            },
                            _vm._l(_vm.categoryList1, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.name,
                                  value: item.tmCategoryId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ssrManage.category2"),
                            prop: "category2Id",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: !_vm.canEditCategory,
                                clearable: "",
                              },
                              model: {
                                value: _vm.formData.category2Id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "category2Id", $$v)
                                },
                                expression: "formData.category2Id",
                              },
                            },
                            _vm._l(_vm.categoryList2, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.name,
                                  value: item.tmCategoryId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { disabled: !_vm.canEdit, label: "Status" } },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: {
                              value: _vm._f("ic")(
                                _vm.viewStatus,
                                "TT_SSR",
                                "STATUS_VIEW"
                              ),
                              clearable: "",
                              disabled: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(`${_vm.type}Manage.${_vm.type}Name`),
                            prop: "name",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { disabled: !_vm.canEdit, clearable: "" },
                            model: {
                              value: _vm.formData.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "name", $$v)
                              },
                              expression: "formData.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("ssrManage.description") } },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { disabled: !_vm.canEdit, clearable: "" },
                            model: {
                              value: _vm.formData.productDescription,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "productDescription",
                                  $$v
                                )
                              },
                              expression: "formData.productDescription",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ssrManage.marketScope"),
                            prop: "marketScope",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              maxlength: "300",
                              autosize: "",
                              disabled: !_vm.canEdit,
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.marketScope,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "marketScope", $$v)
                              },
                              expression: "formData.marketScope",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              `${_vm.type}Manage.${_vm.type}Objective`
                            ),
                            prop: "ssrObjective",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              maxlength: "300",
                              autosize: "",
                              disabled: !_vm.canEdit,
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.ssrObjective,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "ssrObjective", $$v)
                              },
                              expression: "formData.ssrObjective",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("span", { staticStyle: { "padding-right": "15px" } }, [
                    _vm._v(_vm._s(_vm.$t("ssrManage.supplierList"))),
                  ]),
                  _vm.canEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.showSupplierDialog = true
                            },
                          },
                        },
                        [_vm._v("New")]
                      )
                    : _vm._e(),
                  _vm.canEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.delSupplier },
                        },
                        [_vm._v("Delete")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "supplierList",
                  staticStyle: { "margin-top": "15px" },
                  attrs: {
                    data: _vm.formData.ssrSupplierList,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _vm.canEdit
                    ? _c("el-table-column", { attrs: { type: "selection" } })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "supplierCode",
                      label: _vm.$t("ssrManage.invitationCode"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "supplierName",
                      label: _vm.$t("ssrManage.supplierName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "contacts",
                      label: _vm.$t("ssrManage.contacts"),
                      "column-key": "contacts",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `ssrSupplierList[${scope.$index}].contacts`,
                                  "label-width": "0",
                                  rules: _vm.rules.supplierContacts,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: !_vm.canEdit,
                                    clearable: "",
                                  },
                                  model: {
                                    value: scope.row.contacts,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "contacts", $$v)
                                    },
                                    expression: "scope.row.contacts",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "email",
                      label: _vm.$t("ssrManage.email"),
                      "column-key": "email",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `ssrSupplierList[${scope.$index}].email`,
                                  "label-width": "0",
                                  rules: _vm.rules.supplierEmail,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: !_vm.canEdit,
                                    clearable: "",
                                  },
                                  model: {
                                    value: scope.row.email,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "email", $$v)
                                    },
                                    expression: "scope.row.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("div", { staticStyle: { "margin-top": "15px" } }, [
                _vm._v("Schedule of Events"),
              ]),
              _c(
                "el-table",
                {
                  ref: "scheduleList",
                  staticStyle: { "margin-top": "15px" },
                  attrs: {
                    data: _vm.formData.events,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "projectItem",
                      label: _vm.$t("ssrManage.projectItem"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.canEdit && scope.row.canDel == "Y"
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "0",
                                      prop: `events[${scope.$index}].projectItem`,
                                      rules: _vm.rules.projectItem,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: scope.row.projectItem,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "projectItem",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.projectItem",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.projectItem)),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "startDate",
                      label: _vm.$t("ssrManage.beginDate"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.canEdit
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "0",
                                      prop: `events[${scope.$index}].startDate`,
                                      rules: _vm.rules.eventDeadline,
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd",
                                        "picker-options": {
                                          disabledDate:
                                            _vm.eventDisableStartDate(
                                              scope.$index
                                            ),
                                        },
                                        type: "date",
                                      },
                                      model: {
                                        value: scope.row.startDate,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "startDate", $$v)
                                        },
                                        expression: "scope.row.startDate",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("dateFormatFilter")(
                                        scope.row.startDate
                                      )
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "deadline",
                      label: _vm.$t("ssrManage.timeline"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.canEdit
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "0",
                                      prop: `events[${scope.$index}].deadline`,
                                      rules: _vm.rules.eventDeadline,
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd",
                                        "picker-options": {
                                          disabledDate: _vm.eventDisableDate(
                                            scope.$index
                                          ),
                                        },
                                        type: "date",
                                      },
                                      model: {
                                        value: scope.row.deadline,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "deadline", $$v)
                                        },
                                        expression: "scope.row.deadline",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("dateFormatFilter")(
                                        scope.row.deadline
                                      )
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "proposal",
                      label: _vm.$t("ssrManage.remark"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.canEdit
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "0",
                                      prop: `events[${scope.$index}].remark`,
                                      rules: _vm.rules.remark,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "el-input__inner",
                                      model: {
                                        value: scope.row.remark,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "remark", $$v)
                                        },
                                        expression: "scope.row.remark",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("span", [_vm._v(_vm._s(scope.row.remark))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { "show-overflow-tooltip": "", width: "280" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.canEdit & (scope.row.canDel == "Y")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delScheduleRow(scope.$index)
                                      },
                                    },
                                  },
                                  [_vm._v("Delete")]
                                )
                              : _vm._e(),
                            _vm.canEdit
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addScheduleRow(
                                          scope.row,
                                          scope.$index,
                                          "up"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("ssrManage.upAdd")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.canEdit
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addScheduleRow(
                                          scope.row,
                                          scope.$index,
                                          "down"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("ssrManage.downAdd")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "15px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.ganttChartLoad },
                    },
                    [_vm._v("Gantt Chart")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isSupplier,
                      expression: "!isSupplier",
                    },
                  ],
                  staticStyle: { "margin-top": "15px" },
                },
                [_vm._v("Information")]
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isSupplier,
                      expression: "!isSupplier",
                    },
                  ],
                  ref: "informationList",
                  staticClass: "PQCP",
                  staticStyle: { "margin-top": "15px", width: "500px" },
                  attrs: {
                    data: _vm.informationList,
                    border: "",
                    "highlight-current-row": "",
                    "show-header": false,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { selectable: () => _vm.canEdit, type: "selection" },
                  }),
                  _c("el-table-column", { attrs: { prop: "type" } }),
                  _c("el-table-column", {
                    attrs: { prop: "name" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.code == "needVolumeForecast"
                              ? _c(
                                  "div",
                                  [
                                    _vm.canEdit
                                      ? _c(
                                          "el-upload",
                                          {
                                            attrs: {
                                              headers: _vm.uploadHeader,
                                              "show-file-list": false,
                                              "http-request":
                                                _vm.uploadVolumeForecast,
                                              multiple: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              { attrs: { type: "primary" } },
                                              [_vm._v("Upload")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      _vm.formData.volumeForecastFiles,
                                      function (file, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: {
                                              "line-height": "40px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadFile(
                                                      file
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(file.documentName)
                                                ),
                                              ]
                                            ),
                                            _vm.canEdit
                                              ? _c("el-button", {
                                                  staticStyle: {
                                                    "margin-left": "20px",
                                                  },
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini",
                                                    icon: "el-icon-delete",
                                                    circle: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.delInformationDocs(
                                                        file,
                                                        "volumeForecastFiles",
                                                        index
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : scope.row.code == "needCapacityAnalysis"
                              ? _c(
                                  "div",
                                  [
                                    _vm.canEdit
                                      ? _c(
                                          "el-upload",
                                          {
                                            attrs: {
                                              headers: _vm.uploadHeader,
                                              "show-file-list": false,
                                              "http-request":
                                                _vm.uploadCapacityAnalysis,
                                              multiple: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              { attrs: { type: "primary" } },
                                              [_vm._v("Customize")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      _vm.formData.capacityAnalysisFiles,
                                      function (file, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: {
                                              "line-height": "40px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadFile(
                                                      file
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(file.documentName)
                                                ),
                                              ]
                                            ),
                                            _vm.canEdit
                                              ? _c("el-button", {
                                                  staticStyle: {
                                                    "margin-left": "20px",
                                                  },
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini",
                                                    icon: "el-icon-delete",
                                                    circle: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.delInformationDocs(
                                                        file,
                                                        "capacityAnalysisFiles",
                                                        index
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : scope.row.code == "needCostBreakdown"
                              ? _c(
                                  "div",
                                  [
                                    _vm.canEdit
                                      ? _c(
                                          "el-upload",
                                          {
                                            attrs: {
                                              headers: _vm.uploadHeader,
                                              "show-file-list": false,
                                              "http-request":
                                                _vm.uploadCostBreakdown,
                                              multiple: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              { attrs: { type: "primary" } },
                                              [_vm._v("Customize")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      _vm.formData.costBreakdownFiles,
                                      function (file, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: {
                                              "line-height": "40px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadFile(
                                                      file
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(file.documentName)
                                                ),
                                              ]
                                            ),
                                            _vm.canEdit
                                              ? _c("el-button", {
                                                  staticStyle: {
                                                    "margin-left": "20px",
                                                  },
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini",
                                                    icon: "el-icon-delete",
                                                    circle: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.delInformationDocs(
                                                        file,
                                                        "costBreakdownFiles",
                                                        index
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : scope.row.code == "needOtherFormat"
                              ? _c(
                                  "div",
                                  [
                                    _vm.canEdit
                                      ? _c(
                                          "el-upload",
                                          {
                                            attrs: {
                                              headers: _vm.uploadHeader,
                                              "show-file-list": false,
                                              "http-request":
                                                _vm.uploadOtherFormat,
                                              multiple: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              { attrs: { type: "primary" } },
                                              [_vm._v("Upload")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      _vm.formData.otherFormatFiles,
                                      function (file, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: {
                                              "line-height": "40px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadFile(
                                                      file
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(file.documentName)
                                                ),
                                              ]
                                            ),
                                            _vm.canEdit
                                              ? _c("el-button", {
                                                  staticStyle: {
                                                    "margin-left": "20px",
                                                  },
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini",
                                                    icon: "el-icon-delete",
                                                    circle: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.delInformationDocs(
                                                        file,
                                                        "otherFormatFiles",
                                                        index
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            scope.row.code == "needPqcp" ||
                            scope.row.code == "needLogisticCapacity"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadTemplate(
                                              scope.row.type
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("ssrManage.downloadTemplate")
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.showCostBreakdown
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isSupplier,
                          expression: "!isSupplier",
                        },
                      ],
                      staticStyle: { "margin-top": "15px" },
                    },
                    [
                      _vm._v("Cost Breakdown "),
                      _vm.canEdit
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.addCostBreakdownList },
                            },
                            [_vm._v("Add")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showCostBreakdown
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isSupplier,
                          expression: "!isSupplier",
                        },
                      ],
                      ref: "costBreakdownList",
                      staticStyle: { "margin-top": "15px", width: "600px" },
                      attrs: {
                        data: _vm.costBreakdownList,
                        border: "",
                        "highlight-current-row": "",
                        "show-header": false,
                      },
                    },
                    [
                      _c("el-table-column", { attrs: { type: "index" } }),
                      _c("el-table-column", {
                        attrs: { prop: "type", width: "250" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: `costBreakdownColumns[${scope.$index}]`,
                                        rules: _vm.rules.costBreakdown,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "300px" },
                                        attrs: {
                                          disabled:
                                            !_vm.canEdit ||
                                            [0, 1, 2].indexOf(scope.$index) >=
                                              0 ||
                                            scope.$index ==
                                              _vm.costBreakdownList.length - 1,
                                        },
                                        model: {
                                          value: scope.row.name,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "name", $$v)
                                          },
                                          expression: "scope.row.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.canEdit &&
                                  scope.$index > 0 &&
                                  [0, 1, 2].indexOf(scope.$index) < 0 &&
                                  scope.$index <
                                    _vm.costBreakdownList.length - 1
                                    ? _c("i", {
                                        staticClass: "el-icon-top",
                                        staticStyle: {
                                          "font-size": "18px",
                                          color: "red",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeSort(
                                              scope.row,
                                              scope.$index,
                                              "up"
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.canEdit &&
                                  [0, 1, 2].indexOf(scope.$index) < 0 &&
                                  scope.$index <
                                    _vm.costBreakdownList.length - 2
                                    ? _c("i", {
                                        staticClass: "el-icon-bottom",
                                        staticStyle: {
                                          "font-size": "18px",
                                          "padding-left": "15px",
                                          color: "green",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeSort(
                                              scope.row,
                                              scope.$index,
                                              "down"
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3125164555
                        ),
                      }),
                      _vm.canEdit
                        ? _c("el-table-column", {
                            attrs: { prop: "type", width: "80" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return _vm.canEdit &&
                                      [0, 1, 2].indexOf(scope.$index) < 0 &&
                                      scope.$index <
                                        _vm.costBreakdownList.length - 1
                                      ? [
                                          _c(
                                            "el-link",
                                            {
                                              attrs: { type: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.costBreakdownList.splice(
                                                    scope.$index,
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Delete")]
                                          ),
                                        ]
                                      : undefined
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticStyle: { color: "#ccc" } }),
              _c(
                "div",
                { staticStyle: { "margin-top": "15px" } },
                [
                  _vm._v("Corresponding CQS "),
                  _vm.canEdit
                    ? _c(
                        "pickup-category-leader",
                        {
                          attrs: {
                            "query-conditions": { type: "CQS" },
                            multi: true,
                            "pick-type": "1",
                          },
                          on: { pickUp: _vm.addCqs },
                        },
                        [_vm._v("Add")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "correspondingList",
                  staticStyle: { "margin-top": "15px", width: "500px" },
                  attrs: {
                    data: _vm.correspondingList,
                    border: "",
                    "highlight-current-row": "",
                    "show-header": false,
                  },
                },
                [
                  _c("el-table-column", {
                    key: "cqsName",
                    attrs: { prop: "name" },
                  }),
                  _vm.canEdit
                    ? _c("el-table-column", {
                        key: "cqsAction",
                        attrs: { width: "200" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.correspondingList.splice(
                                            scope.$index,
                                            1
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          867329953
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.correspondingList.length > 0
                ? _c(
                    "div",
                    { staticStyle: { "padding-top": "15px" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { disabled: !_vm.canEdit },
                          model: {
                            value: _vm.uploadSpec,
                            callback: function ($$v) {
                              _vm.uploadSpec = $$v
                            },
                            expression: "uploadSpec",
                          },
                        },
                        [_vm._v("Product Spec Required")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.uploadSpec && _vm.correspondingList.length > 0
                ? _c("file-upload", {
                    attrs: {
                      "show-title": false,
                      "rec-type": "SSR",
                      "biz-id": _vm.formData.ttSsrId,
                      seq: "PRODUCT_SPEC",
                      multiple: true,
                      disabled: !_vm.canUploadSpec,
                    },
                    on: {
                      "on-delete-success": _vm.afterDeleteSpec,
                      "on-upload-success": _vm.afterUploadSuccess,
                    },
                    model: {
                      value: _vm.formData.productSpecFiles,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "productSpecFiles", $$v)
                      },
                      expression: "formData.productSpecFiles",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "padding-top": "15px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _vm.canEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.preIssue()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("ssrManage.announce")))]
                  )
                : _vm._e(),
              _vm.canEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v("Save As Draft")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.routerBack } },
                [_vm._v(_vm._s("Close"))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("supplier-dialog", {
        attrs: {
          "is-show": _vm.showSupplierDialog,
          "create-fun": _vm.onSupplier,
        },
        on: {
          "update:isShow": function ($event) {
            _vm.showSupplierDialog = $event
          },
          "update:is-show": function ($event) {
            _vm.showSupplierDialog = $event
          },
          hideDialog: function ($event) {
            _vm.showSupplierDialog = false
          },
        },
      }),
      _c("ssr-issue-dialog", {
        attrs: {
          roundNumber: _vm.formData.currentRound,
          mailTos: _vm.mailTos,
          mailCcs: _vm.mailCcs,
          mailBccs: _vm.mailBccs,
          "ssr-id": _vm.formData.ttSsrId,
          "is-show": _vm.showIssueDialog,
          "create-fun": _vm.onIssue,
        },
        on: {
          issued: function ($event) {
            return _vm.afterIssued()
          },
          "update:isShow": function ($event) {
            _vm.showIssueDialog = $event
          },
          "update:is-show": function ($event) {
            _vm.showIssueDialog = $event
          },
          hideDialog: function ($event) {
            _vm.showIssueDialog = false
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: { title: "Chart", visible: _vm.showGantt },
          on: {
            close: function ($event) {
              _vm.showGantt = false
            },
          },
        },
        [
          _c("Echart", {
            attrs: {
              scheduleList: _vm.formData.events,
              eventActualDate: _vm.eventActualDate,
              name: _vm.formData.name,
              show: _vm.showGantt,
              "create-date": _vm.formData.createDate,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }